import {
  REPORT_SUBSCRIPTION_FREQUENCIES,
  REPORT_SUBSCRIPTION_TYPES,
} from '@/@types/report-subscription';
import { Modal } from '@/components/common';
import { ModalTitle } from '@/components/common/Modal/common';
import {
  REPORT_SUBSCRIPTION_FREQUENCY_LABELS,
  REPORT_SUBSCRIPTION_TYPE_LABELS,
} from '@/modules/report-subscriptions/constants';
import {
  ReportSubscriptionFilterOption,
  ReportSubscriptionFrequencyFilterOption,
  ReportSubscriptionStatusFilterOption,
} from '@/modules/report-subscriptions/hooks/use-report-subscriptions-filters';
import {
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';

interface ReportSubscriptionsFiltersModalProps {
  isOpen: boolean;
  reportType: ReportSubscriptionFilterOption;
  frequency: ReportSubscriptionFrequencyFilterOption;
  isActive: ReportSubscriptionStatusFilterOption;
  // eslint-disable-next-line no-unused-vars
  onReportTypeChange: (value: ReportSubscriptionFilterOption) => void;
  // eslint-disable-next-line no-unused-vars
  onFrequencyChange: (value: ReportSubscriptionFrequencyFilterOption) => void;
  // eslint-disable-next-line no-unused-vars
  onIsActiveChange: (value: ReportSubscriptionStatusFilterOption) => void;
  onClose: () => void;
  onApply: () => void;
}

export function ReportSubscriptionsFiltersModal({
  isOpen,
  reportType,
  frequency,
  isActive,
  onReportTypeChange,
  onFrequencyChange,
  onIsActiveChange,
  onClose,
  onApply,
}: ReportSubscriptionsFiltersModalProps) {
  return (
    <Modal open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
      <ModalTitle title="Filtros" onClose={onClose} />
      <DialogContent sx={{ p: 2 }}>
        <Stack spacing={2} pt={1}>
          <FormControl fullWidth>
            <InputLabel id="report-subscription-type-label">
              Relatório
            </InputLabel>
            <Select
              labelId="report-subscription-type-label"
              value={reportType}
              label="Relatório"
              onChange={({ target }) =>
                onReportTypeChange(
                  target.value as ReportSubscriptionFilterOption
                )
              }
            >
              <MenuItem value="todos">Todos</MenuItem>
              {REPORT_SUBSCRIPTION_TYPES.map((type) => (
                <MenuItem key={type} value={type}>
                  {REPORT_SUBSCRIPTION_TYPE_LABELS[type]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="report-subscription-frequency-label">
              Frequência
            </InputLabel>
            <Select
              labelId="report-subscription-frequency-label"
              value={frequency}
              label="Frequência"
              onChange={({ target }) =>
                onFrequencyChange(
                  target.value as ReportSubscriptionFrequencyFilterOption
                )
              }
            >
              <MenuItem value="todos">Todas</MenuItem>
              {REPORT_SUBSCRIPTION_FREQUENCIES.map((item) => (
                <MenuItem key={item} value={item}>
                  {REPORT_SUBSCRIPTION_FREQUENCY_LABELS[item]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="report-subscription-status-label">
              Status
            </InputLabel>
            <Select
              labelId="report-subscription-status-label"
              value={isActive}
              label="Status"
              onChange={({ target }) =>
                onIsActiveChange(
                  target.value as ReportSubscriptionStatusFilterOption
                )
              }
            >
              <MenuItem value="todos">Todos</MenuItem>
              <MenuItem value="true">Ativos</MenuItem>
              <MenuItem value="false">Inativos</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
        <Button onClick={onClose}>Fechar</Button>
        <Button variant="contained" onClick={onApply}>
          Aplicar
        </Button>
      </DialogActions>
    </Modal>
  );
}
